import React from 'react';
import PropTypes from 'prop-types';
import { v4 } from 'uuid';

const Select = ({
  className,
  disabled,
  onChange,
  options,
  placeholder,
  style,
  value,
}) => {
  return (
    <select
      onChange={onChange}
      value={value}
      className={`select__input ${className}`}
      name={value}
      disabled={disabled}
      style={style}
    >
      {placeholder && <option value="PLACEHOLDER">{placeholder}</option>}
      {options.map(({ value, displayName }) => (
        <option key={v4()} value={value} data-testid={value}>
          {displayName}
        </option>
      ))}
    </select>
  );
};

Select.propTypes = {
  className: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
      ]),
      displayName: PropTypes.string.isRequired,
    })
  ).isRequired,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
};

Select.defaultProps = {
  placeholder: '',
  className: '',
  value: '',
};

export default Select;
